/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { DocumentClassification } from '../enums/document-classification.enum';

export class ActorMailRecipientDto {
  public documentsToReceive: DocumentClassification;
  public id: string = undefined;
  public mailAddress: string = undefined;
}
